import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { LockIcon } from '@calendly/ui/components/icons';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerWithBorderBottomCss = "c1d66f49";
const containerCss = "c17xlj6s";
const Container = forwardRef((props, ref) => {
  const {
    withBorderBottom,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerWithBorderBottomCss]: withBorderBottom
  }, props.className)} />;
});
const contentCss = "c1ezw20s";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const iconWrapperCss = "isb4lbo";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const styledProTipCss = "s1nxzzhq";
const StyledProTip = forwardRef((props, ref) => <ProTip ref={ref} {...props} className={classNames(styledProTipCss, props.className)} />);
const flexContainerCss = "f19hji1m";
const FlexContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexContainerCss, props.className)} />;
});
const flexContainerGrowCss = "fzmuezl";
const FlexContainerGrow = forwardRef((props, ref) => <FlexContainer ref={ref} {...props} className={classNames(flexContainerGrowCss, props.className)} />);
export const EditingRestricted = ({
  subsection,
  lockingDisables = true,
  fontWeight = 'bold'
}) => {
  const text = lockingDisables ? I18n.t('publisher.managed_event_types.event_type.locked.admin_disabled') : I18n.t('publisher.managed_event_types.event_type.locked.admin_restricted');
  if (subsection) {
    return <ContextualBanner icon={LockIcon}>
        {text}
      </ContextualBanner>;
  }
  return <Container withBorderBottom={fontWeight === 'standard'}>
      <Content>
        <FlexContainerGrow>
          <FlexContainer>
            <IconWrapper>
              <LockIcon />
            </IconWrapper>
            <BodyText weight={fontWeight}>
              {text}
            </BodyText>
          </FlexContainer>
          <StyledProTip>
            {I18n.t('publisher.managed_event_types.event_type.locked.protip')}
          </StyledProTip>
        </FlexContainerGrow>
      </Content>
    </Container>;
};

require("./editing_restricted.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./editing_restricted.js");